<template>
  <div class="Aboutus">
    <div class="Aboutus-background">
      <div class="NewCape-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        关于一卡通设置
      </div>
      <div class="Aboutus-imgicon"><img src="../../public/obraoag/Aboutusicon.png" alt=""></div>
      <p class="Aboutus-title">版本号: 1005</p>
      <div class="Aboutus-agreement" @click="abouveon(2)">版本说明</div>
      <div class="Aboutus-agreement Aboutus-contact" @click="abouveon(1)">意见反馈</div>
      <a href="tel:4009284868"><div class="Aboutus-agreement Aboutus-contact">联系客服</div></a>
      <router-link :to="{path:'userment'}"><div class="Aboutus-agreement Aboutus-contact">服务协议</div></router-link>
    </div>
    <!-- 提示语 -->
    <div class="js_dialog" id="iosDialog2" :style="'display:' + abouhint">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__bd" v-if="this.abtprus == '1'">客服电话: 4009284868<br>周一至周六 9:00 - 11:30 14:00 - 17:30</div>
        <div class="weui-dialog__bd" v-else-if="this.abtprus == '2'" style="text-align: left;">
          1. 支持对欧卡的绑定、充值及消费,欧卡的移动管家<br>
          2. 为用户提供充值、转账及消费的服务<br>
          3. 为商家提供展示平台
        </div>
        <div class="weui-dialog__ft">
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" @click="abouclpt()" style="color: #f10100">知道了</a>
        </div>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>


<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      abouhint: 'none',
      abtprus: ''
    }
  },
  created(){
    
  },
  mounted(){
     
  },
  methods:{
    // 点击版本说明和意见反馈
    abouveon(abstus){
      this.abtprus = abstus;
      this.abouhint = 'block';
    },
    // 点击知道了触发
    abouclpt(){
      this.abouhint = 'none';
    },
    // 返回上一层
    BackLevel(){
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
  @import "obraocs/Aboutus.css";
</style>